import classNames from 'classnames';
import * as React from 'react';
import Icon from '../../icons/Icon';
import css from './ServiceFooterSingleHeadingAccordion.module.scss';

interface Props extends React.HTMLProps<{}> {
  className?: string;
  name: string;
  copy: string;
}

const ServiceFooterSingleHeadingAccordion = (props: Props) => {
  const classes = classNames(
    css.ServiceFooterSingleHeadingAccordion,
    props.className,
  );
  return (
    <div className={classes}>
      <input
        id={props.name}
        type="checkbox"
        className={css.ServiceFooterSingleHeadingAccordion__Input}
      />
      <label
        htmlFor={props.name}
        className={css.ServiceFooterSingleHeadingAccordion__Head}
      >
        <div className={css.ServiceFooterSingleHeadingAccordion__Head__Brand}>
          <span className={css.ServiceFooterSingleHeadingAccordion__Head__Copy}>
            {props.copy}
          </span>
        </div>
        <Icon
          name="descend-gr"
          className={css.ServiceFooterSingleHeadingAccordion__Head__Icon}
        />
      </label>
      <div className={css.ServiceFooterSingleHeadingAccordion__Show}>
        {props.children}
      </div>
    </div>
  );
};

export default ServiceFooterSingleHeadingAccordion;
